<div class="wizard">
  <div class="wizard-header">
    <div class="wizard-head-left">
      <div class="wizard-title">{{ headerTitle }}</div>
      <div class="wizard-subtitle">{{ headerDesc }}</div>
    </div>

    <div class="wizard-step">
      {{ stepIndex + 1 }} / {{ totalSteps }}
    </div>
  </div>

  <div class="wizard-progress">
    <div class="wizard-progress-bar" [style.width.%]="progress"></div>
  </div>

  <div class="wizard-body">
    <!-- STEP 1: TIPO DE CARGO -->
    <ng-container *ngIf="stepIndex === 0">
      <div *ngIf="jobTypesLoading" class="wizard-loading">Cargando tipos de cargo...</div>
      <app-select-search
        *ngIf="!jobTypesLoading"
        class="wizard-select"
        [_dataSource]="jobTypes"
        [textInput]="''"
        [dataShow]="'Name'"
        [dataValue]="'Id'"
        [isCard]="false"
        [isCardImage]="false"
        [isDescription]="false"
        (onSelectionChange)="onSelectPositionType($event)"
        [siteCtrl]="ctrlPositionType"
        [inputType]="'text'"
        [selectOpen]="true"
        [placeholder]="'Buscar...'">
      </app-select-search>
    </ng-container>

    <!-- STEPS 2+: GRUPOS (sharedGroups + specificGroups) -->
    <ng-container *ngIf="stepIndex > 0">
      <div *ngIf="groupsLoading" class="wizard-loading">Cargando preguntas...</div>
      <mat-form-field *ngIf="!groupsLoading" class="wizard-select" appearance="outline">
        <mat-select
          [value]="groupControls[stepIndex - 1]?.value"
          (selectionChange)="selectGroupOption($event.value)"
          placeholder="Seleccionar...">
          <mat-option *ngFor="let opt of displayOptions" [value]="opt.Id">
            {{ opt.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>

  <div class="wizard-actions">
    <button mat-stroked-button type="button" class="btn-back" (click)="backOrClose()">
      {{ stepIndex === 0 ? 'Cancelar' : 'Atrás' }}
    </button>

    <button
      mat-raised-button
      type="button"
      class="btn-next"
      (click)="nextOrSave()"
      [disabled]="isNextDisabled()">
      {{ (stepIndex > 0 && stepIndex === totalSteps - 1) ? 'Guardar' : 'Siguiente' }}
    </button>
  </div>
</div>
